import { render, staticRenderFns } from "./FundDetails.vue?vue&type=template&id=ce252da0&scoped=true"
import script from "./FundDetails.vue?vue&type=script&lang=js"
export * from "./FundDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce252da0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce252da0')) {
      api.createRecord('ce252da0', component.options)
    } else {
      api.reload('ce252da0', component.options)
    }
    module.hot.accept("./FundDetails.vue?vue&type=template&id=ce252da0&scoped=true", function () {
      api.rerender('ce252da0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/conventional/dialogs/FundDetails.vue"
export default component.exports